import React, { useState, useRef } from 'react';
import { useOnClickOutside } from '../../utils';
import MoreActions from '../icons/MoreActions';
import editImg from '../../assets/images/edit.svg';
import deleteImg from '../../assets/images/delete.svg';

const StakeholderCell = ({
  stakeholder,
  index,
  setSelected,
  setShowDeleteStakeholderModal,
  setShowEditStakeholderModal,
  setEditStackholderName,
}) => {
  const ref = useRef();
  const exceptional = useRef();
  const [showActions, setShowActions] = useState(false);

  const toggleActions = () => {
    setShowActions(!showActions);
  };

  useOnClickOutside(ref, () => setShowActions(false), exceptional);

  const handleShowDeleteModal = () => {
    setSelected(stakeholder);
    setShowActions(false);
    setShowDeleteStakeholderModal(true);
  };

  const handleShowEditModal = () => {
    setEditStackholderName(stakeholder.name);
    setSelected(stakeholder);
    setShowActions(false);
    setShowEditStakeholderModal(true);
  };

  return (
    <div className="stake-item" key={stakeholder.id}>
      <div className="main-section">
        <p>#{index}</p>
        <div>{stakeholder.name}</div>
      </div>
      <div className="more-actions" onClick={() => toggleActions()} ref={exceptional}>
        <MoreActions color={showActions ? '#01244E' : '#B8C0CC'} />
      </div>
      {showActions && (
        <div className="actions" ref={ref}>
          <div className="action-item" onClick={() => handleShowEditModal()}>
            <img src={editImg} alt="edit" />
            <span>Edit Stakeholder</span>
          </div>
          <div className="action-item" onClick={() => handleShowDeleteModal()}>
            <img src={deleteImg} alt="delete" />
            <span>Delete Stakeholder</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StakeholderCell;
